import { useCallback } from "react";
import { useSlice } from "@bridge-applications/provider-kit";
import { AudioSettingsSliceSchema } from "../../schemas/slices/AudioSettingsSliceSchema";
import { writeStoredAudioSettings } from "../helpers/audioSettingsStorage";

export function useAudioSettings() {
    const { state: audioSettings, setSlice: setAudioSettingsSlice } =
        useSlice("audioSettingsSlice");

    const updateAudioSettings = useCallback(
        (patch: Partial<typeof audioSettings>) => {
            const nextAudioSettings = AudioSettingsSliceSchema.parse({
                ...audioSettings,
                ...patch,
            });
            setAudioSettingsSlice(nextAudioSettings);
            writeStoredAudioSettings(nextAudioSettings);
        },
        [audioSettings, setAudioSettingsSlice],
    );

    const setSlotMachineMusicEnabled = useCallback(
        (slotMachineMusicEnabled: boolean) => {
            updateAudioSettings({ slotMachineMusicEnabled });
        },
        [updateAudioSettings],
    );

    const setCareerMusicEnabled = useCallback(
        (careerMusicEnabled: boolean) => {
            updateAudioSettings({ careerMusicEnabled });
        },
        [updateAudioSettings],
    );

    const setSoundEffectsEnabled = useCallback(
        (soundEffectsEnabled: boolean) => {
            updateAudioSettings({ soundEffectsEnabled });
        },
        [updateAudioSettings],
    );

    return {
        audioSettings,
        setSlotMachineMusicEnabled,
        setCareerMusicEnabled,
        setSoundEffectsEnabled,
    };
}
